<template>
  <div class="min-h-screen bg-[#F8FAFC] p-4 md:p-8 lg:p-10 font-sans text-slate-900 selection:bg-indigo-100">
    
    <header class="max-w-[1600px] mx-auto mb-10 animate-fade-in-down">
      <div class="flex md:flex-row justify-between items-start md:items-center gap-6 mb-8">
        <div class="space-y-1">
          <h1 class="text-3xl md:text-4xl font-black text-slate-900 tracking-tight">
            Écrans de l'agence
          </h1>
          <p class="text-slate-500 font-medium flex items-center gap-2">
            <span class="flex h-2 w-2">
              <span class="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-indigo-400 opacity-75"></span>
              <span class="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
            </span>
            Suivi des devices Screen et pilotage du contenu dynamique.
          </p>
        </div>

        <div class="flex items-center gap-3 w-full max-w-3/4">
          <button 
            @click="fetchScreens"
            class="p-3 bg-white border border-slate-200 rounded-2xl text-slate-400 hover:text-indigo-600 hover:border-indigo-200 hover:shadow-md transition-all active:scale-95"
            title="Rafraîchir les données"
          >
            <svg class="w-5 h-5" :class="{ 'animate-spin': loading }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>

                <div class="bg-white w-full p-4 rounded-[2rem] shadow-sm border border-slate-200/60 mb-8 flex md:flex-row gap-4 items-center animate-fade-in-down" style="animation-delay: 100ms;">
        <div class="flex-1 w-full relative">
          <span class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
          </span>
          <input 
            type="text" 
            v-model="search" 
            placeholder="Rechercher par ID, Nom ou Agence..." 
            class="w-full pl-12 pr-4 py-3.5 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-indigo-100 focus:bg-white transition-all text-sm font-medium"
          >
        </div>
        
        <div class="flex items-center gap-2  md:w-auto overflow-x-auto pb-2 md:pb-0">
          <button 
            v-for="filter in ['all', 'online', 'offline']" 
            :key="filter"
            @click="currentFilter = filter"
            :class="currentFilter === filter ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-100' : 'bg-slate-50 text-slate-500 hover:bg-slate-100'"
            class="px-5 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap"
          >
            {{ filter === 'all' ? 'Tous' : filter }}
          </button>
        </div>
      </div>
        </div>
      </div>

      <div class="grid sm:grid-cols-3 gap-4 mb-4">
        <div class="bg-white p-5 rounded-[2rem] border border-slate-200/60 shadow-sm flex items-center gap-4">
          <div class="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-2xl flex items-center justify-center">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          </div>
          <div>
            <p class="text-[10px] font-black text-slate-400 uppercase tracking-[0.1em]">Total Écrans</p>
            <p class="text-2xl font-black text-slate-900">{{ screens.length }}</p>
          </div>
        </div>
        <div class="bg-white p-5 rounded-[2rem] border border-slate-200/60 shadow-sm flex items-center gap-4">
          <div class="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M5 13l4 4L19 7" /></svg>
          </div>
          <div>
            <p class="text-[10px] font-black text-slate-400 uppercase tracking-[0.1em]">Opérationnels</p>
            <p class="text-2xl font-black text-emerald-600">{{ screens.filter(s => s.online).length }}</p>
          </div>
        </div>
        <div class="bg-white p-5 rounded-[2rem] border border-slate-200/60 shadow-sm flex items-center gap-4">
          <div class="w-12 h-12 bg-rose-50 text-rose-600 rounded-2xl flex items-center justify-center">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          </div>
          <div>
            <p class="text-[10px] font-black text-slate-400 uppercase tracking-[0.1em]">Déconnectés</p>
            <p class="text-2xl font-black text-rose-600">{{ screens.filter(s => !s.online).length }}</p>
          </div>
        </div>
      </div>
    </header>

    <div class="max-w-[1600px] mx-auto">


      <div class="bg-white rounded-[2.5rem] shadow-xl shadow-slate-200/50 overflow-hidden border border-slate-200/60 animate-fade-in-down" style="animation-delay: 200ms;">
        
        <div v-if="loading" class="divide-y divide-slate-50">
          <div v-for="n in 6" :key="n" class="p-8 flex items-center justify-between animate-pulse">
            <div class="flex gap-4 items-center w-1/4">
              <div class="w-12 h-12 bg-slate-100 rounded-2xl"></div>
              <div class="space-y-2 flex-1">
                <div class="h-4 bg-slate-100 rounded w-full"></div>
                <div class="h-3 bg-slate-100 rounded w-2/3"></div>
              </div>
            </div>
            <div class="h-4 bg-slate-100 rounded w-20"></div>
            <div class="h-8 bg-slate-100 rounded-full w-24"></div>
            <div class="h-10 bg-slate-100 rounded-xl w-32"></div>
          </div>
        </div>

        <div v-else-if="filteredScreens.length === 0" class="p-20 text-center flex flex-col items-center justify-center">
          <div class="w-24 h-24 bg-slate-50 rounded-full flex items-center justify-center mb-6">
            <svg class="w-12 h-12 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="1.5" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          </div>
          <h3 class="text-xl font-black text-slate-900 mb-2">Aucun écran trouvé</h3>
          <p class="text-slate-400 font-medium max-w-xs mx-auto">Nous n'avons trouvé aucun écran correspondant à vos critères de recherche ou de filtrage.</p>
          <button @click="search = ''; currentFilter = 'all'" class="mt-6 text-indigo-600 font-black text-xs uppercase tracking-widest hover:underline">Réinitialiser les filtres</button>
        </div>

        <template v-else>
          <div class="overflow-x-auto custom-scrollbar">
            <table class="w-full border-collapse">
              <thead>
                <tr class="bg-slate-50/50 text-left text-[11px] font-black uppercase tracking-[0.2em] text-slate-400 border-b border-slate-100">
                  <th class="px-8 py-6">Écran / Infos</th>
                  <th class="px-8 py-6">Agence</th>
                  <th class="px-6 py-6 text-center">Statut Flux</th>
                  <th class="px-6 py-6">Dernière MAJ</th>
                  <th class="px-8 py-6 text-right">Actions de Pilotage</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50">
                <tr 
                  v-for="screen in paginatedScreens" 
                  :key="screen.id" 
                  class="hover:bg-slate-50/80 transition-all duration-200 group"
                >
                  <td class="px-8 py-6">
                    <div class="flex items-center gap-4">
                      <div class="w-12 h-12 rounded-2xl bg-white border border-slate-200 shadow-sm flex items-center justify-center text-slate-400 group-hover:scale-110 group-hover:text-indigo-500 group-hover:border-indigo-100 transition-all">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                      </div>
                      <div>
                        <div class="font-black text-slate-900 group-hover:text-indigo-600 transition-colors">{{ screen.name || 'Sans nom' }}</div>
                        <div class="text-[10px] text-slate-400 font-mono uppercase tracking-tighter">{{ screen.id }}</div>
                      </div>
                    </div>
                  </td>

                  <td class="px-8 py-6">
                    <div class="flex flex-col">
                      <span class="text-sm font-bold text-slate-700">{{ screen.agencyName }}</span>
                      <span class="text-[10px] text-slate-400 font-medium">Zone: {{ screen.identifier || 'N/A' }}</span>
                    </div>
                  </td>

                  <td class="px-6 py-6 text-center">
                    <span 
                      :class="statusClasses(screen.status)" 
                      class="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-[10px] font-black uppercase tracking-wider border shadow-sm transition-all"
                    >
                      <span class="w-1.5 h-1.5 rounded-full bg-current" :class="{ 'animate-pulse': screen.online }"></span>
                      {{ screen.statusLabel }}
                    </span>
                  </td>

                  <td class="px-6 py-6">
                    <div class="flex flex-col">
                      <span class="text-sm font-medium text-slate-600 tabular-nums">{{ screen.lastUpdate }}</span>
                      <span class="text-[10px] text-slate-400 uppercase font-bold">Synchronisé</span>
                    </div>
                  </td>
                  
                  <td class="px-8 py-6 text-right">
                    <div class="flex justify-end gap-2 opacity-0 group-hover:opacity-100 transition-all translate-x-4 group-hover:translate-x-0">
                      
                      <button 
                        @click="openWaitingRoom(screen)"
                        class="p-3 bg-white border border-slate-200 text-slate-400 hover:text-indigo-600 hover:border-indigo-100 hover:bg-indigo-50 rounded-xl transition-all shadow-sm group/btn"
                        title="Visionner le flux live"
                      >
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                        </svg>
                      </button>

                      <button 
                        @click="goToEditor(screen)"
                        class="p-3 bg-white border border-slate-200 text-slate-400 hover:text-orange-600 hover:border-orange-100 hover:bg-orange-50 rounded-xl transition-all shadow-sm"
                        title="Éditer le design"
                      >
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                      </button>

                      <button 
                        @click="handleRemoteReset(screen)"
                        class="p-3 bg-white border border-slate-200 text-slate-400 hover:text-rose-600 hover:border-rose-100 hover:bg-rose-50 rounded-xl transition-all shadow-sm"
                        title="Redémarrer à distance"
                      >
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="px-8 py-6 bg-slate-50/50 border-t border-slate-100 flex sm:flex-row items-center justify-between gap-4">
            <p class="text-[11px] font-black text-slate-400 uppercase tracking-widest">
              Affichage {{ paginatedScreens.length }} sur {{ filteredScreens.length }} résultats
            </p>
            
            <div class="flex items-center gap-2">
              <button 
                @click="currentPage--" 
                :disabled="currentPage === 1"
                class="px-4 py-2 rounded-xl border border-slate-200 bg-white text-slate-600 text-[10px] font-black uppercase disabled:opacity-40 hover:bg-slate-50 transition-all"
              >
                Précédent
              </button>
              
              <div class="flex gap-1">
                 <button v-for="p in totalPages" :key="p" 
                  @click="currentPage = p"
                  :class="currentPage === p ? 'bg-indigo-600 text-white shadow-md shadow-indigo-100' : 'bg-white text-slate-400 border border-slate-200'"
                  class="w-8 h-8 rounded-lg text-[10px] font-black transition-all"
                 >
                  {{ p }}
                 </button>
              </div>

              <button 
                @click="currentPage++" 
                :disabled="currentPage >= totalPages"
                class="px-4 py-2 rounded-xl border border-slate-200 bg-white text-slate-600 text-[10px] font-black uppercase disabled:opacity-40 hover:bg-slate-50 transition-all"
              >
                Suivant
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <Transition name="fade">
      <div v-if="showAddModal" class="fixed inset-0 bg-slate-900/60 backdrop-blur-md z-50 flex items-center justify-center p-4">
        <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-md p-8 animate-scale-in border border-white/20">
          <div class="flex justify-between items-center mb-8">
            <h3 class="text-2xl font-black text-slate-900 tracking-tight">Nouvel Écran</h3>
            <button @click="showAddModal = false" class="text-slate-400 hover:text-slate-600 transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2.5" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>

          <form @submit.prevent="saveNewScreen" class="space-y-5">
            <div>
              <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 px-1">ID Unique du Device</label>
              <input 
                v-model="newScreen.id" 
                type="text" 
                required
                class="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl focus:ring-0 focus:border-indigo-500 transition-all outline-none font-bold text-slate-800"
                placeholder="Ex: SCR-001-PARIS"
              >
            </div>

            <div>
              <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 px-1">Nom d'usage</label>
              <input 
                v-model="newScreen.name" 
                type="text" 
                required
                class="w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl focus:ring-0 focus:border-indigo-500 transition-all outline-none font-bold text-slate-800"
                placeholder="Ex: Écran Vitrine Droite"
              >
            </div>

            <div class="pt-4 flex gap-3">
              <button 
                type="button"
                @click="showAddModal = false" 
                class="flex-1 py-4 rounded-2xl border-2 border-slate-100 text-slate-400 font-black text-xs uppercase tracking-[0.15em] hover:bg-slate-50 transition-all"
              >
                Annuler
              </button>
              <button 
                type="submit"
                class="flex-1 py-4 rounded-2xl bg-indigo-600 text-white font-black text-xs uppercase tracking-[0.15em] hover:bg-indigo-700 shadow-xl shadow-indigo-100 transition-all transform active:scale-95"
              >
                Confirmer
              </button>
            </div>
          </form>
        </div>
      </div>
    </Transition>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

/**
 * LOGIQUE ET ÉTAT
 */
const router = useRouter()
const API_BASE = 'https://api.datafuse.fr/api/super-admin'

const screens = ref([])
const loading = ref(true)
const search = ref('')
const currentFilter = ref('all')
const showAddModal = ref(false)

// Pagination
const currentPage = ref(1)
const itemsPerPage = ref(10)

const newScreen = ref({
  id: '',
  name: '',
  status: 'active'
})

/**
 * COMPUTED: FILTRAGE & RECHERCHE
 */
const filteredScreens = computed(() => {
  let result = screens.value

  // 1. Filtre par onglet (Status)
  if (currentFilter.value === 'online') {
    result = result.filter(s => s.online)
  } else if (currentFilter.value === 'offline') {
    result = result.filter(s => !s.online)
  }

  // 2. Recherche texte
  if (search.value) {
    const s = search.value.toLowerCase()
    result = result.filter(sc => 
      sc.id.toLowerCase().includes(s) || 
      sc.name?.toLowerCase().includes(s) ||
      sc.agencyName?.toLowerCase().includes(s) ||
      sc.statusLabel?.toLowerCase().includes(s)
    )
  }

  return result
})

const totalPages = computed(() => Math.ceil(filteredScreens.value.length / itemsPerPage.value))

const paginatedScreens = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  return filteredScreens.value.slice(start, start + itemsPerPage.value)
})

/**
 * ACTIONS & API
 */
const fetchScreens = async () => {
  loading.value = true
  try {
    const token = localStorage.getItem("superAdminToken")
    if (!token) {
      toast.error("Session expirée")
      return
    }

    const res = await fetch(`${API_BASE}/screens`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    if (!res.ok) throw new Error("Erreur serveur")

    const data = await res.json()
    
    // Mapping des données avec formatage date propre
    screens.value = data.map(s => ({
      ...s,
      status: s.online ? "active" : "inactive",
      statusLabel: s.online ? "Live Now" : "Déconnecté",
      lastUpdate: s.lastUpdate 
        ? new Date(s.lastUpdate).toLocaleString('fr-FR', { 
            day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' 
          })
        : 'Jamais'
    }))
  } catch (err) {
    console.error("Fetch Error:", err)
    toast.error("Échec de la synchronisation du parc")
  } finally {
    // Timeout artificiel pour une transition fluide du skeleton
    setTimeout(() => { loading.value = false }, 400)
  }
}

const saveNewScreen = async () => {
  try {
    // Simulation API - à adapter selon votre endpoint POST /screens
    toast.info(`Initialisation du screen ${newScreen.value.id}...`)
    
    // Simulation succès
    setTimeout(() => {
      toast.success("Nouvel écran configuré avec succès")
      showAddModal.value = false
      fetchScreens()
    }, 1000)
  } catch (err) {
    toast.error("Erreur lors de la création")
  }
}

/**
 * HELPERS & NAVIGATION
 */
const statusClasses = (status) => {
  if (status === 'active') return 'bg-emerald-50 text-emerald-600 border-emerald-100'
  if (status === 'maintenance') return 'bg-amber-50 text-amber-400 border-amber-100'
  return 'bg-rose-50 text-rose-500 border-rose-100'
}

const openWaitingRoom = (screen) => {
  router.push({ path: '/waitingRoom', query: { token: screen.connectionToken } })
}

const goToEditor = (screen) => {
  // ✅ Passer le deviceId dans la query pour pré-sélectionner cet écran dans l'éditeur
  console.log(screen)
  console.log('🚀 Navigation vers éditeur - Screen ID:', screen.id, 'Agency ID:', screen.agencyId);
  router.push({
    path: `/screen-editor/${screen.agencyId}`,
    query: { deviceId: screen.id }
  })
}

const handleRemoteReset = (screen) => {
  toast.promise(
    new Promise((resolve) => setTimeout(resolve, 2000)),
    {
      pending: `Signal de reset envoyé à ${screen.name}...`,
      success: 'Device réinitialisé 👌',
      error: 'Échec de la communication 🤯'
    }
  )
}

/**
 * WATCHERS & LIFECYCLE
 */
watch([search, currentFilter], () => {
  currentPage.value = 1
})

onMounted(() => {
  fetchScreens()
})
</script>

<style scoped>
/* Scrollbar Custom */
.custom-scrollbar::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #E2E8F0;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #CBD5E1;
}

/* Animations */
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-12px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fade-in-down {
  animation: fadeInDown 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.96) translateY(10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.animate-scale-in {
  animation: scaleIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>